<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    
    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
      
        <a-form-model-item
            prop="name"
          label="项目名称">
          <a-input placeholder="请输入项目名称" v-model="model.name" />
        </a-form-model-item>
        <a-form-model-item
            prop="startDate"
          label="预计开启时间">
          <a-date-picker showTime valueFormat='YYYY-MM-DD HH:mm:ss' v-model="model.startDate" />
        </a-form-model-item>
        <a-form-model-item
            prop="centerNames"
          label="项目实施中心">
          <a-input placeholder="请输入项目实施中心" v-model="model.centerNames" />
        </a-form-model-item>
        <a-form-model-item
            prop="centerIds"
          label="项目实施中心">
          <a-input placeholder="请输入项目实施中心" v-model="model.centerIds" />
        </a-form-model-item>
        <!-- <a-form-model-item
            prop="beforeTest"
          label="是否开启预实验，1是0否">
          <a-input placeholder="请输入是否开启预实验，1是0否" v-model="model.beforeTest" />
        </a-form-model-item> -->
        <a-form-model-item
            prop="testNum"
          label="实验人数">
          <a-input-number v-model="model.testNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入实验人数" />
        </a-form-model-item>
        <a-form-model-item
            prop="personName"
          label="项目负责人">
          <a-input placeholder="请输入项目负责人" v-model="model.personName" />
        </a-form-model-item>
        <a-form-model-item
            prop="personId"
          label="项目负责人">
          <a-input placeholder="请输入项目负责人" v-model="model.personId" />
        </a-form-model-item>
        <a-form-model-item
            prop="phone"
          label="联系电话">
          <a-input placeholder="请输入联系电话" v-model="model.phone" />
        </a-form-model-item>
        <a-form-model-item
            prop="intro"
          label="项目简介">
          <a-input placeholder="请输入项目简介" v-model="model.intro" />
        </a-form-model-item>
		
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'

  export default {
    name: "TempConfigProjectModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        rules:{},
        confirmLoading: false,

        url: {
          add: "/tempconfig/tempConfigProject/add",
          edit: "/tempconfig/tempConfigProject/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>